import { AreaId } from './SearchSuggestionsTownsAndCities.types';
import CityIcon from './images/City_icon.png';
import CoastIcon from './images/Coast_icon.png';
import CountrysideIcon from './images/Countryside_icon.png';
import PopularLocationsIcon from './images/Popular_locations_icon.png';

export const sectionIcon = (id: AreaId) => {
    switch (id) {
        case 'in-the-city':
            return CityIcon;
        case 'on-the-coast':
            return CoastIcon;
        case 'rural-and-countryside':
            return CountrysideIcon;
        case 'popular-locations':
            return PopularLocationsIcon;
        case 'trending-areas':
            return CountrysideIcon;
        default:
            return undefined;
    }
};
